<template>
  <div class="relative lg:px-12 md:px-12 px-4 lg:mt-0 md:mt-0">
    <img src="@/assets/images/line/Vector 9.png" alt="lineimg" class="m-auto" />
    <PopupNeedHelp
      :isActive="isDetailsActive"
      :selectedNeedHelp="selectedNeedHelp"
      @close="toggleDetails"
    />
    <div class="">
      <!-- temp-h995px -->
      <div
        class="lg:flex md:flex justify-center lg:ml-10 md:ml-10 ml-12 m-auto"
      >
        <div
          class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 rounded-2xl lg:w-auto md:w-auto w-3/5 m-auto absolute lg:top-36 md:top-36 top-0"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p
                class="font-semibold lg:text-left md:text-left text-center text-black fsize20 sm-fsize14"
              >
                Support group is a safe place to interact with family
                caregivers<br />
                and share your experience
              </p>
              <div
                class="lg:pl-14 md:pl-14 lg:pt-0 md:pt-0 pt-2 items-center flex lg:justify-start md:justify-start justify-center"
              >
                <a href="https://chat.whatsapp.com/H4TUoGPJGIpJJ3b5NXHUNe">
                  <base-button
                    type="primary"
                    class="lg:py-2 md:py-2 lg:px-8 md:px-8 px-2 fsize16-14 font-bold border-2 mt-2 md:mt-0 lg:mt-0 whitespacenowrap mx-auto md:w-auto lg:w-auto w-full"
                    @click="handleClick('Whatsapp')"
                    >Join our support group
                  </base-button></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="lg:py-0 md:py-12 py-5 lg:flex md:flex lg:items-center md:items-start z-10 relative"
      >
        <!-- <div class="absolute bg-design8 mob-hidden md-hidden">
          <img
            src="../../../assets/images/dots.svg"
            alt="bg-polygon"
            class="h-full w-full"
          />
        </div> -->
        <!-- <div class="absolute bg-design9 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd9.svg"
            alt="bg-polygon"
            class=""
          />
        </div>
        <div class="absolute bg-design10 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full w-full"
          />
        </div> -->
        <div class="lg:w-1/2 md:w-1/2 w-full">
          <div class="m-auto h-full lg:pt-0 md-pt-0 lg:pr-10 md:pr-10">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/homepage/Medical-Condition.webp"
              alt=""
              class="lg:ml-auto md:ml-auto custborderradius"
            />
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 lg:pt-0 md:pt-0 pt-5 w-full">
          <div class="my-auto">
            <p class="title md:font-normal lg:font-normal font-bold sm-fsize16">
              Medical Conditions
            </p>
            <div class="lg:pt-0 md:pt-0 pt-4">
              <p class="subtitle lh32px sm-fsize14">
                Some of the condition specific support that we provide are for
                the following.
              </p>
              <div
                class="lg:pt-10 md:pt-10 pt-6 lg:grid md:grid lg:grid-cols-2 md:grid-cols-1 lg:grid-rows-2 md:grid-rows-2 lg:gap-8 md:gap-8"
              >
                <div
                  class="bgCCEFF2 p-6 rounded-xl z-10 lg:mb-0 md:mb-0 mb-4"
                  v-for="(item, index) in medicalcards"
                  :key="index"
                  :style="{ 'background-color': item.color }"
                >
                  <div
                    class="flex justify-between items-center cursor-pointer"
                    @click="handleClickpage(item.text)"
                  >
                    <!-- @click="toggleDetails(true, item)" -->
                    <p class="text-xl text-black font-semibold">
                      {{ item.text }}
                    </p>
                    <div class="">
                      <img :src="item.img" alt="" class="h-8 w-8" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="relative">
      <img
        src="@/assets/images/line/Vector 28.png"
        alt="lineimg"
        class="m-auto"
      />
      <div class="flex justify-center mt-neg2 lg:ml-10 md:ml-10">
        <div
          class="borderprimary bg-white absolute lg:top-24 md:top-24 top-4 lg:p-4 md:p-4 rounded-2xl lg:w-auto md:w-auto w-3/5 lg:m-auto md:m-auto lg:mt-12 md:mt-12"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
              <p
                class="font-semibold lg:text-left md:text-left text-center text-black fsize20 sm-fsize14"
              >
                Your contribution can help
                <span class="lg:block md:block">Empower a Caregiver</span>
              </p>
              <div
                class="lg:pl-14 md:pl-14 lg:pt-0 md:pt-0 pt-4 items-center flex lg:justify-start md:justify-start justify-center"
              >
                <!-- <a
                  href="https://pages.razorpay.com/caregiversaathi-donation"
                  alt="link"
                  target="_blank"
                >
                </a> -->
                <!-- <base-button
                  type="primary"
                  @click="handleClick('donation')"
                  class="lg:py-2 md:py-2 lg:px-8 md:px-8 px-2 font-bold border-2 md:w-auto lg:w-auto w-3/4 fsize16-14"
                  >Donate1</base-button
                > -->
                <a
                  target="_blank"
                  href="https://pages.razorpay.com/caregiversaathi-donation"
                >
                  <b-button
                    variant="primary"
                    class="lg:py-2 md:py-2 lg:px-8 md:px-8 px-2 font-bold border-2 md:w-auto lg:w-auto w-full fsize16-14"
                    >Donate</b-button
                  >
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WhyUs />
    </div>
  </div>
</template>
<script>
import WhyUs from "./WhyUs";
import PopupNeedHelp from "./PopupNeedHelp.vue";
export default {
  components: {
    PopupNeedHelp,
    WhyUs,
  },
  data() {
    return {
      selectedNeedHelp: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          text: "Dementia",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. It can be of various kinds, Alzheimer’s being the most common one. Family caregivers of people with dementia are important to the quality of the patient’s life. The effects of being a long-term caregiver often includes psychological burden and social isolation. Our community, support groups and counselling offer you the time and space to share your experiences and unburden your closed emotions.",
        },
        {
          id: "02",
          text: "Cancer",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
          description:
            "Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care and home-based care offers you opportunities to create checks and balances for your long-term caregiving needs.",
        },
        {
          id: "03",
          text: " Neurological Disorders",
          img: require("../../../assets/images/right.png"),
          color: "#eee2ff",
          description:
            "Amyotrophic Lateral Sclerosis or ALS is a  Neurological Disorders that progressively leads to loss of voluntary muscle movements. Currently, there is no cure for ALS, and neither any effective treatment to halt or reverse the progression of the disease. Informal caregiving for a loved one with ALS can be physically and mentally stressful. Our educational resources and learning programmes can equip you with better knowledge and skills to provide effective caregiving. Simultaneously, our support services enable you to focus on your well-being.",
        },
        {
          id: "04",
          text: "Palliative",
          img: require("../../../assets/images/right.png"),
          color: "#cceff2",
          description:
            "Palliative care is a specialized form of healthcare that focuses on providing relief from the symptoms and stress of serious illnesses. The goal of palliative care is to improve the quality of life for both the patient and their family by addressing physical, emotional, and spiritual needs. Palliative care is not just for patients who are terminally ill, but for those who are dealing with serious illnesses that affect their daily lives.",
        },
      ],
    };
  },
  methods: {
    // toggleDetails(val = false, item = {}) {
    //   this.isDetailsActive = val;
    //   this.selectedNeedHelp = item;
    // },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleClickpage(name) {
      if (name.trim() == "Neurological Disorders") {
        this.$router.push({ name: "medical_neurologicaldisorders" });
      } else if (name === "Dementia") {
        this.$router.push({ name: "medical_dementia" });
      } else if (name === "Palliative") {
        this.$router.push({ name: "medical_palliative" });
      } else if (name === "Cancer") {
        this.$router.push({ name: "medical_cancer" });
      }
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-top29 {
    top: 25rem;
  }
  .sm-h-830px {
    height: 830px !important;
  }
}
</style>
